var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",class:_vm.type},[_c('strong',[_vm._v(_vm._s(_vm.formatNameForIcon(_vm.person)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }